import React from 'react'
import { ListItem, ListItemPrefix } from "@material-tailwind/react";

const ListItemTab = ({ icon: Icon, label, onClick, active }) => {
  return (
    <ListItem
      onClick={onClick}
      className={`transition-colors 
        ${
          active
            ? "!bg-yellow-50 !text-yellow-800 border border-yellow-400"
            : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
        }`}
    >
      <ListItemPrefix>
        <Icon className="h-5 w-5" />
      </ListItemPrefix>
      {label}
    </ListItem>
  )
}

export default ListItemTab
